import { render, staticRenderFns } from "./InstallationTable.vue?vue&type=template&id=08875d76"
import script from "./InstallationTable.vue?vue&type=script&lang=js"
export * from "./InstallationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports